<template>
  <div v-if="isDocAprovado" class="mb-3 pa-5" style="border: 1px solid #e0e0e0; border-radius: 8px">
    <h4 class="mb-3 text-descricao">Regra: {{ regraNumber }} - {{ descricao }}</h4>
    <v-autocomplete
      v-if="requiredDoc === 'PELO_MENOS_UM'"
      class="mx-2"
      v-model="documentoSelecionado"
      :items="listaDocumentos"
      item-text="descricao"
      item-value="codigo"
      label="Tipo de documento *"
      return-object
    ></v-autocomplete>
    <section
      v-for="doc in requiredDoc === 'PELO_MENOS_UM' ? [documentoSelecionado] : listaDocumentos"
      :key="doc?.codigo"
    >
      <input
        type="file"
        :id="doc?.codigo"
        ref="fileInputs"
        style="display: none"
        @change="e => handleFileInput(e, doc?.codigo)"
        :disabled="checkIfDocumentosOpcional(requiredDoc, documentoSelecionado)"
        accept=".pdf"
      />
      <a href="#" @click.prevent="selectFile(doc?.codigo)">
        <div
          :class="dropZoneClass(doc)"
          @drop="e => (disabledDrop ? null : dropHandler(e, doc?.codigo))"
          @dragover.prevent="
            e => (disabledDrop ? null : dragOverHandler(e, requiredDoc, documentoSelecionado))
          "
        >
          <v-icon
            size="30"
            v-if="!nomesArquivos[doc?.codigo]"
            :class="doc?.descricao ? 'icon mb-2 mt-2' : 'icon-disable mb-2 mt-2'"
            >upload_file</v-icon
          >
          <v-icon v-if="nomesArquivos[doc?.codigo]" size="30" class="icon-check-file mb-2 mt-2"
            >check_circle</v-icon
          >

          <br />
          <p :class="doc?.descricao ? 'truncate-text' : 'truncate-text truncate-text-disable'">
            {{ doc?.descricao }}
            {{
              !documentoSelecionado && requiredDoc === 'PELO_MENOS_UM'
                ? 'Selecione um tipo de documento'
                : '*'
            }}<br />
            <span :class="doc?.descricao ? 'title-file' : 'title-file-disable'">
              {{ nomesArquivos[doc?.codigo] ? 'Arquivo: ' : '' }}
              {{ nomesArquivos[doc?.codigo] || 'Nenhum arquivo selecionado' }}<br />
            </span>
          </p>
        </div>
        <p class="font--primary" style="font-size: small">
          <v-icon small color="primary">info</v-icon>
          Arquivo deve ser enviado no formato PDF.
        </p>
        <p v-if="fileErro" class="erro">Por favor selecione {{ nome }}</p>
        <!-- {{ fileTypeErro }}{{ tipoDocErro }} -->
        <p v-if="fileTypeErro && tipoDocErro == doc?.codigo" class="erro">
          Arquivo inválido. Enviar documento do tipo PDF*
        </p>
        <p v-if="errorSize" class="erro">
          Arquivo inválido. Enviar documento com tamanho de até 5MB*
        </p>
      </a>
    </section>
  </div>
  <div v-else>
    <section v-for="doc in listaDocumentos" :key="doc?.tipoDocumento">
      <input
        type="file"
        :id="doc?.tipoDocumento"
        ref="fileInputs"
        style="display: none"
        @change="e => handleFileInput(e, doc?.tipoDocumento)"
        :disabled="checkIfDocumentosOpcional(requiredDoc, documentoSelecionado)"
        accept=".pdf"
      />
      <a href="#" @click.prevent="selectFile(doc?.tipoDocumento)">
        <div
          :class="dropZoneClass(doc)"
          @drop="e => (disabledDrop ? null : dropHandler(e, doc?.tipoDocumento))"
          @dragover.prevent="
            e => (disabledDrop ? null : dragOverHandler(e, requiredDoc, documentoSelecionado))
          "
        >
          <v-icon
            size="30"
            v-if="!nomesArquivos[doc?.tipoDocumento]"
            :class="doc?.descricao ? 'icon mb-2 mt-2' : 'icon-disable mb-2 mt-2'"
            >upload_file</v-icon
          >
          <v-icon
            v-if="nomesArquivos[doc?.tipoDocumento]"
            size="30"
            class="icon-check-file mb-2 mt-2"
            >check_circle</v-icon
          >

          <br />
          <p :class="doc?.descricao ? 'truncate-text' : 'truncate-text truncate-text-disable'">
            {{ doc?.descricao }}
            {{
              !documentoSelecionado && requiredDoc === 'PELO_MENOS_UM'
                ? 'Selecione um tipo de documento'
                : '*'
            }}<br />
            <span :class="doc?.descricao ? 'title-file' : 'title-file-disable'">
              {{ nomesArquivos[doc?.tipoDocumento] ? 'Arquivo: ' : '' }}
              {{ nomesArquivos[doc?.tipoDocumento] || 'Nenhum arquivo selecionado' }}<br />
            </span>
          </p>
        </div>
        <p class="font--primary" style="font-size: small">
          <v-icon small color="primary">info</v-icon>
          Arquivo deve ser enviado no formato PDF.
        </p>
        <p v-if="fileErro" class="erro">Por favor selecione {{ nome }}</p>
        <!-- {{ fileTypeErro }}{{ tipoDocErro }} -->
        <p v-if="fileTypeErro && tipoDocErro == doc?.tipoDocumento" class="erro">
          Arquivo inválido. Enviar documento do tipo PDF*
        </p>
        <p v-if="errorSize" class="erro">
          Arquivo inválido. Enviar documento com tamanho de até 5MB*
        </p>
      </a>
    </section>
  </div>
</template>

<script>
import { retry } from 'rxjs';
import { mapActions } from 'vuex';

export default {
  name: 'UploadFile',
  data() {
    return {
      errorSize: false,
      nomesArquivos: {},
      documentoSelecionado: null,
      disabled: true,
      tipoDocErro: '',
      fileTypeErro: false,
      disabledDrop: false,
    };
  },
  props: {
    nome: null,
    isFoto: {
      type: Boolean,
      default: false,
    },
    fileErro: {
      type: Boolean,
      default: false,
    },
    descricao: null,
    listaDocumentos: {
      type: Array,
      default: () => [],
    },
    requiredDoc: {
      type: String,
      default: '',
    },
    fileName: {
      type: String,
      default: '',
    },
    regraNumber: {
      type: String,
      default: '',
    },
    isDocAprovado: {
      type: Boolean,
      default: true,
    },
  },
  computed: {},
  watch: {
    documentoSelecionado(newValue) {
      if (newValue) {
        this.disabled = false;
        this.disabledDrop = false;
        this.$emit('recuperarFileName', newValue.descricao);
      }
    },
  },
  methods: {
    dropZoneClass(doc) {
      if (!doc?.descricao && this.isDocAprovado) return 'drop_zone drop-zone-disable';
      if (!this.isDocAprovado) return 'drop_zone ';
      return this.nomesArquivos[doc?.codigo] ? 'drop_zone_file' : 'drop_zone';
    },
    dragOverHandler(event, requiredDoc, documentoSelecionado) {
      // if (this.validateFormatPDF(event.target.files, tipoDoc)) return;
      event.preventDefault();
    },
    async dropHandler(event, tipoDoc) {
      event.preventDefault();
      let file = null;

      // Primeiro tenta pelo items
      if (event.dataTransfer.items && event.dataTransfer.items.length > 0) {
        file = event.dataTransfer.items[0].getAsFile();
      }
      // Fallback para files
      if (!file && event.dataTransfer.files && event.dataTransfer.files.length > 0) {
        file = event.dataTransfer.files[0];
      }
      if (!file) return;

      const isInvalid = await this.validateFormatPDF(file, tipoDoc);
      if (isInvalid) return this.$set(this.nomesArquivos, tipoDoc, '');

      if (file.size > 5242880) {
        this.errorSize = true;
      } else {
        const base64 = await this.converterParaBase64(file);
        this.$set(this.nomesArquivos, tipoDoc, file.name);
        this.setFormArquivos({
          conteudoBase64: base64,
          tipoDocumento: tipoDoc,
        });
        this.$emit('file', file);
        this.errorSize = false;
      }
      this.removeDragData(event);
    },
    selectFile(id) {
      const input = Array.from(this.$refs.fileInputs).find(el => el.id === id);
      if (input) input.click();
    },
    async handleFileInput(event, tipoDoc) {
      if (await this.validateFormatPDF(event.target.files[0], tipoDoc))
        return this.$set(this.nomesArquivos, tipoDoc, '');
      if (event.target.files[0]) {
        const file = event.target.files[0];

        this.errorSize = false;
        const base64 = await this.converterParaBase64(file);
        this.$set(this.nomesArquivos, tipoDoc, file.name); // Vue reativo

        this.setFormArquivos({
          conteudoBase64: base64,
          tipoDocumento: tipoDoc,
        });
      }
    },
    removeDragData(event) {
      if (event.dataTransfer.items) {
        event.dataTransfer.items.clear();
      }
    },
    converterParaBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const base64 = reader.result.split(',')[1]; // remove o prefixo
          resolve(base64);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    checkIfDocumentosOpcional(requiredDoc, documentoSelecionado) {
      if (requiredDoc === 'PELO_MENOS_UM' && documentoSelecionado == null) {
        this.disabledDrop = true;
      }
      return (
        requiredDoc === 'PELO_MENOS_UM' &&
        documentoSelecionado &&
        ![documentoSelecionado].length > 0
      );
    },
    async validateFormatPDF(file, tipoDoc) {
      let isRealPDF = await this.isRealPDF(file);
      this.fileTypeErro = !isRealPDF;
      this.tipoDocErro = tipoDoc;
      return !isRealPDF;
    },
    async isRealPDF(file) {
      return new Promise(resolve => {
        const reader = new FileReader();

        reader.onloadend = function (e) {
          const arr = new Uint8Array(e.target.result);

          // Pega o início do arquivo
          const start = String.fromCharCode(...arr.subarray(0, 5));

          // Pega o final do arquivo (últimos ~20 bytes, suficiente para %%EOF)
          const endBytes = arr.subarray(arr.length - 20);
          const end = new TextDecoder().decode(endBytes);

          const validStart = start.startsWith('%PDF');
          const validEnd = end.includes('%%EOF');

          resolve(validStart && validEnd);
        };

        // Lê todo o arquivo (pode ser pesado em PDFs grandes, mas garante checagem correta)
        reader.readAsArrayBuffer(file);
      });
    },
    ...mapActions('spgc', ['setFormArquivos']),
  },
};
</script>

<style lang="scss" scoped>
.drop_zone {
  border: 1px dashed #444a4c;
  border-radius: 4px;
  width: 99%;
  height: 130px;
  padding-top: 8px;
  margin-left: 1.5px;
  text-align: center;
  background-color: #c5dbee;
  margin-top: -5px;
  margin-bottom: 12px;
}
.drop_zone_file {
  border: 1px dashed #444a4c;
  border-radius: 4px;
  width: 99%;
  height: 130px;
  padding-top: 8px;
  margin-left: 1.5px;
  text-align: center;
  background-color: #c5dbee;
  margin-top: -5px;
  margin-bottom: 12px;
}
.drop-zone-disable {
  border: 1px dashed #969999;
  border-radius: 4px;
  width: 99%;
  height: 130px;
  padding-top: 8px;
  margin-left: 1.5px;
  text-align: center;
  background-color: #acbdcc;
  margin-top: -5px;
  margin-bottom: 12px;
}
.truncate-text {
  color: #444a4c;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 4px;
}
.truncate-text-disable {
  color: #828484;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 4px;
}
.erro {
  color: #f61a1a;
  font-size: 11.5px;
  margin-top: -10px;
  padding-left: 8px;
}
.icon {
  color: #444a4c;
}
.icon-disable {
  color: #828484;
}
.text-descricao {
  color: #4a4b4b !important;
  font-weight: bold;
  font-size: 15px;
  padding-left: 8px;
}
.icon-check-file {
  color: #1e60c2;
}
.title-file {
  font-weight: bold;
  font-size: 14px;
  color: #444a4c;
}
.title-file-disable {
  font-weight: bold;
  font-size: 14px;
  color: #828484;
}
</style>
